import { Word as l, Align as a } from "./components.js";
const d = /* @__PURE__ */ new WeakMap();
function x(e) {
  let t = d.get(e);
  return t || (t = {
    textMeshes: /* @__PURE__ */ new Map(),
    textContent: /* @__PURE__ */ new Map(),
    defaultFont: null,
    measureFn: null
  }, d.set(e, t)), t;
}
function g(e, t) {
  x(e).measureFn = t;
}
function b(e, t) {
  const n = x(e), c = n.textContent.get(t) || "", r = l.fontSize[t];
  if (n.measureFn)
    return n.measureFn(c, r);
  const u = n.textMeshes.get(t);
  if (u?.textRenderInfo) {
    const [o, , s] = u.textRenderInfo.blockBounds;
    return s - o;
  }
  return 0;
}
function C(e, t, n) {
  x(e).textContent.set(t, n), l.dirty[t] = 1;
}
function F(e, t) {
  return x(e).textContent.get(t) || "";
}
function B(e, t) {
  const n = x(e);
  n.defaultFont = t;
}
function M(e, t, n) {
  const c = x(e), r = c.textMeshes.get(t);
  if (!r) {
    if (c.measureFn) {
      const o = c.textContent.get(t) || "", s = l.fontSize[t], i = c.measureFn(o, s), f = s;
      n({
        width: i,
        height: f,
        blockBounds: [0, 0, i, f],
        visibleBounds: [0, 0, i, f]
      });
    }
    return;
  }
  const u = () => {
    const o = r.textRenderInfo;
    if (o) {
      const [s, i, f, m] = o.blockBounds;
      n({
        width: f - s,
        height: m - i,
        blockBounds: o.blockBounds,
        visibleBounds: o.visibleBounds
      });
    }
  };
  r.textRenderInfo ? u() : r.sync(u);
}
function k(e, t, n, c) {
  const r = e.reduce((s, i) => s + i, 0) + (e.length - 1) * t;
  let u = 0;
  for (let s = 0; s < c; s++)
    u += e[s] + t;
  u += e[c] / 2;
  let o;
  switch (n) {
    case a.Left:
      o = 0;
      break;
    case a.Right:
      o = -r;
      break;
    case a.Center:
    default:
      o = -r / 2;
      break;
  }
  return o + u;
}
export {
  F as getTextContent,
  x as getTextContext,
  M as measureText,
  b as measureWordWidth,
  B as setDefaultFont,
  g as setMeasureFn,
  C as setTextContent,
  k as wordPosition
};
//# sourceMappingURL=utils.js.map
